<template>
  <section>
    <ConnectionFail v-model:active="failConnect" />
    <Loading ref="loading" />
    <ToastError ref="toastError" />
    <ToastNotification
      ref="toastAction"
      :type-message="type"
      style="right: 10px; top: 70px;"
    />
  </section>
</template>

<script>
import swal from 'sweetalert2';
import ToastNotification from '@/components/ToastNotification/ToastNotification.vue';
import ConnectionFail from './Dialogues/ConnectionFail.vue';
import Loading from './Dialogues/Loading.vue';
import ToastError from './Dialogues/ToastError.vue';

export default {
  components: {
    ConnectionFail,
    Loading,
    ToastError,
    ToastNotification,
  },
  data() {
    return {
      failConnect: false,
      message: '',
      type: '',
    };
  },
  computed: {
    commandIndex() {
      return {
        fail: this.fail,
        warning: this.warning,
        success: this.success,
        confirm: this.confirm,
      };
    },
  },
  created() {
    this.$eventBus.$on('connection-disabled', this.connectionFail);
    this.$eventBus.$on('alert-command', this.command);
  },
  unmounted() {
    this.$eventBus.$off('connection-disabled', this.connectionFail);
    this.$eventBus.$off('alert-command', this.command);
  },
  methods: {
    command({type, message, cb}) {
      if (this.commandIndex[type]) {
        this.commandIndex[type](message, cb);
      }
    },
    loading(cb) {
      this.$refs.loading.open();
      if (cb) {
        cb(this.$refs.loading);
      }
    },
    closeLoading() {
      this.$refs.loading.close();
    },
    toastError(cb) {
      this.$refs.toastError.open();
      if (cb) {
        cb(this.$refs.toastError);
      }
    },
    close() {
      swal.close();
      this.$refs.loading.close();
    },
    fail(msg, cb) {
      setTimeout(() => {
        this.type = 'danger';
        this.$refs.toastAction.open(msg);
        try { if (cb)cb(); } catch (e) {}
      }, 1000);
    },
    error(msg) {
      this.fail.apply(this, [arguments[0], arguments[1]]);
    },
    warning(msg) {
      this.type = 'warning';
      this.$refs.toastAction.open(msg);
    },
    success(message) {
      this.type = 'success';
      this.$refs.toastAction.open(message);
    },
    confirm(message, cb) {
      swal({
        type: 'warning',
        text: message,
        background: 'rgba(255,255,255,0)',
        customClass: 'no-shadow',
        showCancelButton: true,
        showConfirmButton: true,
        confirmButtonText: 'Yes, I am surre!',
      }).then((result) => {
        if (result.value) {
          cb();
        }
      });
    },
    connectionFail() {
      this.failConnect = true;
    },
  },
};
</script>

<style>
.swal2-container.swal2-shown {
  background-color: rgb(0, 0, 0) !important;
  z-index: 1000000 !important;
}
.no-shadow {
  box-shadow: 0px 0px 0px transparent !important;
}
.no-shadow .swal2-content {
  color: #fff !important;
  font-weight: bold;
}

.swal2-popup .swal2-actions.swal2-loading .swal2-styled.swal2-confirm {
  width: 15em !important;
  height: 15em !important;
  margin: 0.46875em;
  padding: 0;
}
.swal2-icon.swal2-warning {
  font-size: 24px !important;
}
</style>
